module.exports = __webpack_public_path__ + "static/img/culture-mission.8ebe58b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture-mission.png
// module id = VF7R
// module chunks = 1